import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import PropTypes from 'prop-types';
import { LedgerEntryType } from '../../common/Helpers';

const LedgerHashes = (props) => {
	const { node } = props;
    if ( node?.LedgerEntryType === LedgerEntryType.LedgerHashes ) {
        return (
            <>
                {node?.FirstLedgerSequence >= 0 &&
                <tr>
                    <td>FirstLedgerSequence:</td>
                    <td>
                        <span>
                            {node.FirstLedgerSequence}
                        </span>
                    </td>
                </tr>
                }

                {node?.LastLedgerSequence >= 0 &&
                <tr>
                    <td>LastLedgerSequence:</td>
                    <td>
                        <span>
                            {node.LastLedgerSequence}
                        </span>
                    </td>
                </tr>
                }

                {node?.Hashes &&
                <tr>
                    <td>Hashes:</td>
                    <td>
                        <Table responsibe>
                           <thead>
                               <tr>
                                    <th>#</th>
                                    <th>Hash</th>
                                </tr>
                            </thead>
                            <tbody>
                                {node.Hashes.map((Hash, index) => {
                                    return(
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>
                                                <span className='hash'>
                                                    <Link to={`/ledger/${Hash}`}>{Hash}</Link>
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                    })
                                }
                            </tbody>
                        </Table>
                    </td>
                </tr>
                }                
            </>
        );    
    } else {
        return <></>;
    }
}

LedgerHashes.propTypes = {
	node: PropTypes.object,
}

export default LedgerHashes;